import React from "react";
import { FaFacebookF, FaTwitter, FaLinkedinIn } from "react-icons/fa";
import { MdLocationPin, MdEmail } from "react-icons/md";
import { IoCall } from "react-icons/io5";
// import "../../Template02/Combined.css";
import "../../Template02/ContactPage/ContactPage.css";

import Header from "../Header/Header";
import Footer from "../Footer/Footer";

function ContactPage() {
  return (
    <>
      {/* Header */}
      <Header />

      <div>
        <div id="contact" className="page wb-page">
          {/* Breadcrumb Section */}
          <section
            id="section-3592653"
            className="breadcrumb-section dark sec-padding-lg"
            style={{
              backgroundImage:
                "url(https://images.pexels.com/photos/8442620/pexels-photo-8442620.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center center",
            }}
          >
            <div className="container boxWidget">
              <div className="col-lg-6">
                <div className="richTextWidget title-heading">
                  <h1>Contact Us</h1>
                </div>
              </div>
            </div>
          </section>

          <div className="background">
            <div className="container">
              <div className="screen">
                <div className="screen-body">
                  <div className="screen-body-item left">
                    <div className="app-title">
                      {/* <span>Get in touch soon</span> */}
                      <span>We’d Love to Hear From You</span>
                    </div>
                    <div className="app-message ">
                      Join us in shaping the future of research and formulation
                      development. Contact Medisol today to collaborate or learn
                      more about our innovative solutions.
                    </div>
                    <div >
                      <div className="app-contact ">
                        <p className="contact-detail">
                          <span className="fa">
                            <IoCall
                              style={{ color: "#d10f56", marginRight: "4px" }}
                            />
                          </span>
                          <a href="tel: +912269074440" style={{ color: "#fff"}}> +91 2269074440</a>
                        </p>
                        {/* CONTACT INFO : +91 (944) 753-2111 */}
                      </div>
                      <div className="app-contact">
                        <p className="contact-detail">
                          <span className="fa">
                            {/* <MdEmSail
                              style={{ color: "#d10f56", marginRight: "4px" }}
                            /> */}
                          </span>
                          <a href="mailto:support@medisol-lab.com" style={{ color: "#fff"}}>
                            {/* support@medisol-lab.com */}
                          </a>
                        </p>
                        {/* Support@medisol-lab.com */}
                      </div>
                      <div className="app-contact" style={{ display: "flex" }}>
                        <div>
                          {" "}
                          <p className="contact-detail">
                            <span className="fa">
                              <MdLocationPin
                                style={{ color: "#d10f56", marginRight: "4px" }}
                              />
                            </span>
                          </p>
                        </div>
                        <div>
                          <p className="contact-detail">
                            <a href="https://www.google.com/maps" style={{ color: "#fff"}}>
                            Medisol labs Pvt. Ltd.<br/> at Aklara, Tal. Umargam Dist.Valsad (Gujarat), India.
                            </a>
                          </p>
                        </div>
                      </div>
                      <div>
                        <ul style={{ listStyle: "none", display: "flex" }}>
                          <li style={{ marginRight: "15px" }}>
                            <a
                              href="https://www.facebook.com/MedisolLab"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#d10f56",
                                background: "white",
                                padding: "10px",
                                borderRadius: "20px",
                              }}
                            >
                              <FaFacebookF />
                            </a>
                          </li>
                          <li style={{ marginRight: "15px" }}>
                            <a
                              href="https://www.twitter.com/MedisolLab"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#d10f56",
                                background: "white",
                                padding: "10px",
                                borderRadius: "20px",
                              }}
                            >
                              <FaTwitter />
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://www.linkedin.com/company/medisol-lab"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#d10f56",
                                background: "white",
                                padding: "10px",
                                borderRadius: "20px",
                              }}
                            >
                              <FaLinkedinIn />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="screen-body-item right">
                    <div className="app-form">
                      <div className="app-form-group">
                        <input
                          className="app-form-control"
                          type="text"
                          name="name"
                          id="name"
                          required
                          placeholder="Enter your full name"
                        />
                      </div>
                      <div className="app-form-group">
                        <input
                          className="app-form-control"
                          type="email"
                          name="email"
                          id="email"
                          required
                          placeholder="Your email address"
                        />
                      </div>
                      <div className="app-form-group">
                        <input
                          className="app-form-control"
                          type="text"
                          name="phone"
                          id="phone"
                          required
                          placeholder="Your phone number"
                        />
                      </div>
                      <div className="app-form-group message">
                        <textarea
                          className="app-form-control"
                          rows={4}
                          name="message"
                          id="message"
                          required
                          placeholder="Please write your message here"
                        />
                      </div>
                      <div className="app-form-group buttons">
                        <button className="app-form-button">SEND</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </>
  );
}

export default ContactPage;
